import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { TaxRateShiftsDto } from '../dtos';

export enum TaxRateShiftsActionTypes {
  LoadTaxRateShifts = '[TaxRateShifts] LoadTaxRateShifts',
  LoadTaxRateShiftsSuccess = '[TaxRateShifts] LoadTaxRateShiftsSuccess',
  LoadTaxRateShiftsError = '[TaxRateShifts] LoadTaxRateShiftsError',
}

export const loadTaxRateShiftsAction = createAction(TaxRateShiftsActionTypes.LoadTaxRateShifts);
export const loadTaxRateShiftsSuccessAction = createAction(
  TaxRateShiftsActionTypes.LoadTaxRateShiftsSuccess,
  props<{ taxrateShifts: TaxRateShiftsDto[] }>()
);
export const loadTaxRateShiftsErrorAction = createAction(
  TaxRateShiftsActionTypes.LoadTaxRateShiftsError,
  props<{ failure: AppStateFailure }>()
);
